import { Observable } from 'rxjs';
import { ProjectInfoResponse } from '../models/project-info.types';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfigService } from '../../../core/services/api-config.service';

export abstract class ProjectInfoDataSource {
  abstract getProjectInfo(projectId: string): Observable<ProjectInfoResponse>;
}

export class ApiProjectInfoDataSource implements ProjectInfoDataSource {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfigService);

  getProjectInfo(projectId: string): Observable<ProjectInfoResponse> {
    return this.http.get<ProjectInfoResponse>(this.apiConfig.endpoint(`project/${projectId}`));
  }
}
